import { useQuery, useQueryClient } from '@tanstack/react-query';

import { ScheduleWeekTasks } from '@Models';
import { bopsApi } from '@Network';

interface UseScheduleTasksParams {
  scheduleId: string;
  weekStart: string | null;
}

const fetchScheduleListTasks = async (scheduleId: string): Promise<ScheduleWeekTasks> => {
  const items = await bopsApi.getScheduleTasks(scheduleId);
  return { has_own_list: false, has_schedule_list: items.length > 0, items };
};

const useScheduleTasks = ({ scheduleId, weekStart }: UseScheduleTasksParams) =>
  useQuery({
    queryKey: ['schedule-tasks', scheduleId, weekStart ?? 'default'],
    queryFn: () =>
      weekStart ? bopsApi.getScheduleWeekTasks(scheduleId, weekStart) : fetchScheduleListTasks(scheduleId),
  });

const useInvalidateScheduleLists = (scheduleId: string) => {
  const queryClient = useQueryClient();

  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: ['schedule-tasks', scheduleId] }, { throwOnError: true }),
      queryClient.invalidateQueries({ queryKey: ['schedule-weeks', scheduleId] }, { throwOnError: true }),
    ]);
};

export { useInvalidateScheduleLists, useScheduleTasks };
